import { useMininumDeviceWidthBreakpoint } from "@bidbattles/bloks/hooks/media";
import { LucideLoader2 } from "lucide-react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
	const isAtLeastMedium = useMininumDeviceWidthBreakpoint({
		breakpoint: "md",
		serverDefault: true,
	});

	return (
		<Sonner
			className="toaster group"
			position={isAtLeastMedium ? "bottom-right" : "top-center"}
			style={
				{
					"--normal-bg": "var(--color-black)",
					"--normal-text": "var(--color-white)",
					"--normal-border": "var(--color-black)",
				} as React.CSSProperties
			}
			icons={{
				loading: <LucideLoader2 className="animate-spin" />,
			}}
			{...props}
		/>
	);
};

export { Toaster };
